import { Component } from '@angular/core';
import { FirebaseService } from "./providers/firebase.service";
import { Router } from "@angular/router";
import { ShortUrlService } from "./providers/short-url.service";
import { setTheme } from 'ngx-bootstrap/utils';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(
    public afService: FirebaseService,
    public router: Router,
    private shortUrl: ShortUrlService
  ) {
    setTheme('bs3');
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/app.component.ts